<script>
import axios from "axios"
import FormInput from "@/components/forms/FormInput.vue"

export default {
  name: "DataFlowSaveModal",
  components: { FormInput },
  props: {
    dataFlow: {
      type: Object,
      required: true
    },
    isOpened: {
      type: Boolean,
      required: true
    }
  },
  emits: ["close"],
  methods: {
    async handleCreateDataFlow() {
      try {
        // Create DataFlow
        const response = await axios.post(`${process.env.VUE_APP_API}/device-groups`, {
          projectId: this.$route.params.projectId,
          deviceGroupName: this.dataFlow.deviceGroupName,
          deviceGroupDesc: this.dataFlow.deviceGroupDesc,
          technology: this.dataFlow.technology,
          transformationId: this.dataFlow.transformationId
        })

        const dfId = response.data.deviceGroupId

        // Assign endpoints (one by one...)
        for (const endpoint of this.dataFlow.endpoints) {
          await axios.post(`${process.env.VUE_APP_API}/device-groups/${dfId}/endpoints/${endpoint.custDestId}/assign`)
        }

        this.$router.push({ name: "group", params: { ...this.$route.params, id: dfId } })
      } catch (e) {
        console.error(e) // TODO(?) might be useful to handle this
      }
    }
  }
}
</script>

<template>
  <div :class="{ active: isOpened }" class="side-box">
    <span class="side-box__overlay" />
    <!-- kvůli zanořeným modalům pro transformační funkce potřebuju z-index 0 vždy -->
    <div
      :class="{
        opened: isOpened,
        'last-active': true
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="$emit('close')">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button
          :disabled="!dataFlow.deviceGroupName"
          class="btn btn-primary primary-shadow"
          @click="handleCreateDataFlow"
        >
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("FINISH_AND_SAVE") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("NAME_THE_DATA_FLOW") }}</h2>
      </div>
      <div class="side-box__content">
        <FormInput
          :label="$t('TITLE')"
          :placeholder="$t('DATA_FLOW_TITLE_PLACEHOLDER')"
          :value="dataFlow.deviceGroupName || ''"
          class="mb-4"
          side-box
          @input="dataFlow.deviceGroupName = $event"
        />
        <FormInput
          :label="$t('DESCRIPTION')"
          :placeholder="$t('DATA_FLOW_DESCRIPTION_PLACEHOLDER')"
          :value="dataFlow.deviceGroupDesc || ''"
          class="mb-4"
          horizontal
          side-box
          @input="dataFlow.deviceGroupDesc = $event"
        />
      </div>
    </div>
  </div>
</template>
